<template>
  <v-container fluid tag="section">
    <div v-if="item.length === 0">
      <img :src="require('@/assets/images/empty.png')" height="300" :width="$isMobile ? '100%' : 300"/>
    </div>
    <v-row v-for="(itm, idx) in item" :key="idx">
      <v-col cols="12"  v-if="idx !== 0">
        <v-divider class="mb-3"></v-divider>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        类&nbsp;&nbsp;&nbsp;&nbsp;型：<span class="font-weight-black">{{itm.type ===1 ? '客户方' : '渠道方'}}</span>
      </v-col>
      <v-col :cols="$isMobile ? 6 : 12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        客户姓名：<span class="font-weight-black">{{itm.name}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 6 : 4" :class="$isMobile ? 'size-13' : ''">
        联系方式：<span class="font-weight-black">{{itm.phoneNumber}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        微信号码：<span class="font-weight-black">{{itm.wechatNumber}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 3 : 4" :class="$isMobile ? 'size-13' : ''">
        部门职务：<span class="font-weight-black">{{itm.dept}}</span>
      </v-col>
      <v-col cols="12" :md="mini ? 9 : 9" :class="$isMobile ? 'size-13' : ''">
        备注信息：<span class="font-weight-black">{{itm.remark}}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'CustomerContactsDetail',
    components: {
    },
    props: {
      item: {
        type: Array,
        default: () => ([])
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    }
  }
</script>

<style>
</style>
